import * as mtypes from "../generic/mtypes";
import "@/assets/css/style.css";
import { showErrorToast } from "@/utils/alerts";

async function handleRequest(commit, requestPromise, successType, failureType) {
  commit(mtypes.REQUEST_HANDLER);
  try {
    const response = await requestPromise();
    commit(successType, response.data);
  } catch (error) {
    onFailureResponse(commit, failureType, error);
  }
}

async function handleMultiRequest(
  commit,
  requestPromise,
  successType,
  failureType,
) {
  commit(mtypes.REQUEST_HANDLER);
  try {
    let pageNumber = 1;
    let result = { data: [] };
    let hasMore = true;

    do {
      const response = await requestPromise({ pageNumber });
      const responseData = response.data.data.data;
      if (responseData.length === 0) {
        break;
      }

      result.data.push(...responseData);
      pageNumber++;
    } while (hasMore);

    commit(successType, result);
  } catch (error) {
    onFailureResponse(commit, failureType, error);
  }
}

function onFailureResponse(commit, failureType, error) {
  const apiError = error?.response?.data || {};
  commit(failureType, apiError);
  const errorMessage = apiError.ErrorMessage || apiError.errorMessage || "";
  const validationErrors =
    apiError.ValidationErrors || apiError.validationErrors || "";
  showErrorToast(
    `Error de conexión con la API: ${error}`,
    `${errorMessage} \n ${validationErrors}`,
  );
  throw new Error("Error de conexión con la API");
}

export { handleRequest, handleMultiRequest };
